<template>
  <div class="container">
    <figure class="item en" style="margin: auto; text-align: center">
      <figcaption>LimitYangのblog</figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'DanceFont'
}
</script>

<style scoped>
@import './css/style.css';
.container {
  overflow: hidden;
}
</style>
